import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { faqs } from '../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-95" data-mp="1bmd8ncjfgm7p">
      <div className="mx-auto w-full max-w-2xl" data-id="element-96" data-mp="1gitxya2d56md">
        <h2 className="text-center text-[24px] font-black leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-97" data-mp="1glpwo0m1bzbv">
          Frequently asked questions
        </h2>

        <ul className="mt-9 space-y-2.5" data-id="element-98" data-mp="289hv7b0x1rur">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-white" data-id="element-99" data-mp="1zihl0ogfp4ms" data-mpi={index}>
                <h3 data-id="element-100" data-mp="2n7a9jzuq8a7d">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-skysoft focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-cta sm:px-5" data-id="element-101" data-mp="2n6r3bgefva96">
                    <span className="text-[14px] font-extrabold leading-snug text-navy sm:text-[15px]" data-id="element-102" data-mp="19u50hgdalfue">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-cta transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-103" data-mp="1ol492re4o4dz" />
                  </button>
                </h3>
                {isOpen ? <p className="border-t border-navy/10 px-4 py-4 text-[13.5px] leading-relaxed text-navy2 sm:px-5 sm:text-[15px]" data-id="element-104" data-mp="36q1w0li98tr">
                    {faq.a}
                  </p> : null}
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 max-w-md" data-id="element-105" data-mp="237o83oezw3ll">
          <CtaButton label="Get instant access for $27" subLabel="Automatic currency conversion · 7-day guarantee" data-id="element-106" data-mp="238g593o8q9dz" />
        </div>
      </div>
    </section>;
}